const NAV_URL_KEYS = {
  '/index-bs-management': 'nav.home',
  '/user-request': 'nav.publishRequest',
  '/post-request': 'nav.becomeProvider',
  '/provider-signup': 'nav.becomeProvider',
  '/support-sav': 'nav.afterSales',
  '/service-apres-vente': 'nav.afterSales',
  '/auth/login': 'nav.login',
  '/auth/sign-up': 'nav.signup',
  '/auth/signup': 'nav.signup',
  '#demo': 'nav.demos',
};

export function translateNavData(headerData, t) {
  if (!headerData?.menus) return headerData;

  const translateTitle = (url, title, hasSubmenu = false) => {
    const u = String(url || '').trim();
    if (u === '/') return t(hasSubmenu ? 'nav.pages' : 'nav.home');
    const key = NAV_URL_KEYS[u];
    return key ? t(key) : title;
  };

  const menus = headerData.menus.map((menu) => {
    const item = menu.item || {};
    const submenu = item.submenu || {};
    const items = Array.isArray(submenu.items)
      ? submenu.items.map((sub) => ({
          ...sub,
          title: translateTitle(sub.url, sub.title),
        }))
      : [];

    return {
      ...menu,
      item: {
        ...item,
        title: translateTitle(item.url, item.title, items.length > 0),
        submenu: { ...submenu, items },
      },
    };
  });

  const buttonContent = headerData.buttonContent
    ? {
        ...headerData.buttonContent,
        label: t('nav.login'),
      }
    : headerData.buttonContent;

  return { ...headerData, menus, buttonContent };
}
